import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["clearButton", "input"];

  connect() {
    if (this.hasInputTarget) {
      this.toggleClearButton();
    }
  }

  toggleClearButton() {
    if (this.inputTarget.value !== "") {
      this.clearButtonTarget.classList.remove("hidden");
    } else {
      this.clearButtonTarget.classList.add("hidden");
    }
  }

  clearSearch() {
    this.inputTarget.value = "";
    this.clearButtonTarget.classList.add("hidden");
    this._redirectAfterClearSearch()
  }

  _redirectAfterClearSearch() {
    const url = new URL(window.location.href)
    const params = url.searchParams

    if (params.has("q[name_cont]")) {
      params.delete("q[name_cont]")
      params.delete("commit")
      url.search = params.toString()

      const cleanUrl = url.search ? url.toString() : url.origin + url.pathname

      window.location.replace(cleanUrl)
    }
  }
}
